import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
require('es6-promise').polyfill()

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    user: JSON.parse(localStorage.getItem('user')) || null,
    app: JSON.parse(localStorage.getItem('app')) || null,
    access_token: localStorage.getItem('access_token') || ''
  },
  mutations: {
    EVENT_INIT (state) {
      state.status = 'LOADING'
    },
    EVENT_APP (state, data) {
      state.status = 'SUCCESS'
      state.app = data
      localStorage.setItem('app', JSON.stringify(data))
    },
    EVENT_LOGIN (state, data) {
      state.status = 'SUCCESS'
      state.user = data.user
      state.access_token = data.token_type + ' ' + data.access_token
      localStorage.setItem('user', JSON.stringify(data.user))
      localStorage.setItem('access_token', state.access_token)
      axios.defaults.headers.common['Authorization'] = state.access_token
    },
    EVENT_LOGOUT (state) {
      state.status = 'SUCCESS'
      state.user = null
      state.access_token = null
      localStorage.removeItem('user')
      localStorage.removeItem('access_token')
      delete axios.defaults.headers.common['Authorization']
    }
  },
  actions: {
    APP ({ commit }, data) {
      commit('EVENT_INIT')
      commit('EVENT_APP', data)
    },
    LOGIN ({ commit }, data) {
      commit('EVENT_INIT')
      commit('EVENT_LOGIN', data)
    },
    LOGOUT ({ commit }) {
      commit('EVENT_INIT')
      commit('EVENT_LOGOUT')
    }
  },
  getters: {
    access_token: state => state.access_token,
    user: state => state.user,
    app: state => state.app
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js